const crypto = require('crypto');

export const randomRange = function(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const randomAvatar = function(name?: string) {
    const max = 10;
    const random = randomRange(1, max);
    const number = name ? (getFirstNumber(`${crypto.createHash('sha256').update(name).digest()}`) || random) : random;
    const numberNormalized = number < 10 ? `0${number}` : number;

    return `${MEDIA_URL}/avatars/${numberNormalized}.svg`;
}

export const randomAvatarOnError = function(element: HTMLImageElement) {
    const image = new Image();
    image.src = element.src;
    image.onerror = image.onabort = () => element.src = randomAvatar(element.alt || 'avatar');
}

export function getFirstNumber(str: string): number | void {
    const number = (str.match(/^\d+|\d+\b|\d+(?=\w)/g) || []).map(number => {
        return +number;
    }).shift();

    if (number) {
        return parseFloat(number.toString().charAt(0));
    }
}